/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type Plan =
  /** V2021_1 エンタープライズプラン */
  | 'V2021_1Enterprise'
  /** V2021_1 プレミアムプラン */
  | 'V2021_1Premium'
  /** V2021_1 スタンダードプラン */
  | 'V2021_1Standard'
  /** V2022_1 Enterpriseプラン */
  | 'V2022_1Enterprise'
  /** V2022_1 Entryプラン */
  | 'V2022_1Entry'
  /** V2022_1 PRプラン */
  | 'V2022_1PR'
  /** V2022_1 Proプラン */
  | 'V2022_1Pro'
  /** V2022_2 管理者専用無料プラン */
  | 'V2022_2ManageOnlyFree'
  /** V2023_1 エンタープライズプラン */
  | 'V2023_1Enterprise'
  /** V2023_1 エキスパートプラン */
  | 'V2023_1Expert'
  /** V2023_1 管理者専用無料プラン */
  | 'V2023_1ManageOnlyFree'
  /** V2023_1 マスタープラン */
  | 'V2023_1Master'
  /** V2023_1 スキルフォースプラン */
  | 'V2023_1SkillForce';

export type FetchChatRedirectorQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchChatRedirectorQuery = { viewer: { plan: Types.Plan }, uiControl: { viewMatchedRooms: boolean } };


export const FetchChatRedirectorDocument = gql`
    query fetchChatRedirector {
  viewer {
    plan
  }
  uiControl {
    viewMatchedRooms
  }
}
    `;

/**
 * __useFetchChatRedirectorQuery__
 *
 * To run a query within a Vue component, call `useFetchChatRedirectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchChatRedirectorQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchChatRedirectorQuery();
 */
export function useFetchChatRedirectorQuery(options: VueApolloComposable.UseQueryOptions<FetchChatRedirectorQuery, FetchChatRedirectorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchChatRedirectorQuery, FetchChatRedirectorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchChatRedirectorQuery, FetchChatRedirectorQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchChatRedirectorQuery, FetchChatRedirectorQueryVariables>(FetchChatRedirectorDocument, {}, options);
}
export function useFetchChatRedirectorLazyQuery(options: VueApolloComposable.UseQueryOptions<FetchChatRedirectorQuery, FetchChatRedirectorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchChatRedirectorQuery, FetchChatRedirectorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchChatRedirectorQuery, FetchChatRedirectorQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchChatRedirectorQuery, FetchChatRedirectorQueryVariables>(FetchChatRedirectorDocument, {}, options);
}
export type FetchChatRedirectorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchChatRedirectorQuery, FetchChatRedirectorQueryVariables>;